import React, { useState } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Switch,
    FormControlLabel,
    Grid,
    Stack,
    MenuItem,
    Select,
    FormControl,
    Snackbar,
    Alert,
    InputLabel,
    Backdrop,
    CircularProgress,
    Divider,
    InputAdornment,
} from "@mui/material";
import {
    Place, Hotel, Restaurant, CardGiftcard, LocalOffer, LocationOn, Language, Image, Collections,
    Spa, Payments, Groups, AccessTime, WbSunny, Co2, Bolt, WaterDrop, LocalGasStation, Recycling, Park,
    Phone, Map as MapIcon, Notes, Save, Cancel,
} from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { create_places, district_admin, upload_image_all } from "../api/API";
import { AdminPage, SectionTitle, GREEN, LIGHT, BORDER, primaryButtonSx } from "../admin/AdminPageLayout";

// ไอคอนหัวการ์ดตามประเภทสถานที่
const placeTypeIcons = {
    tourist_attraction: Place,
    hotel: Hotel,
    restaurant: Restaurant,
    gift_shop: CardGiftcard,
    community_product: LocalOffer,
};

function MainAddPlaces() {
    const { placeType } = useParams();
    const [initialLoading, setInitialLoading] = useState(true);
    const [form, setForm] = useState({
        placeType: placeType,  // หมวดที่อยู่
        attractionName: "",  // ชื่อสถานที่
        language: "th",  // ภาษา
        historyDescription: "", // ประวัติความเป็นมา
        activities: "", // กิจกรรม
        cost: "", // ค่าใช้จ่าย
        touristCapacity: "", // การรองรับนักท่องเที่ยว
        openingHours: "", // เวลาทำการ
        touristSeason: "", // ฤดูการท่องเที่ยว
        electricityUsage: "", // การใช้ไฟฟ้า
        waterUsage: "", // การใช้น้ำ
        fuelUsage: "", // การใช้น้ำมัน
        wastewaterManagement: "", // การจัดการน้ำและการเปลี่ยนถ่ายน้ำเสีย
        wasteManagement: "", // การจัดการขยะ
        ecoSystemChange: "", // การเปลี่ยนระบบของสถานที่ท่องเที่ยว
        contactInfo: "", // ติดต่อสถานที่s
        locationDescription: "", // ที่ตั้ง
        googleMapCoordinates: "", // Google Map (latitude,longitude)
        notes: "", // หมายเหตุ
        uid: null, // ไอดีผู้ลงข้อมูล
        did: null, // ไอดีจังหวัด

    });
    const [district, setDistrict] = useState([]); // จังหวัด
    const [images, setImages] = useState([]); // รูปภาพ
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);
    const [errorSnackbar, setErrorSnackbar] = useState({
        open: false,
        message: "",
    });
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // "success" | "error" | "warning" | "info"

    useEffect(() => {
        const fetchData = async () => {
            if (!token) return;
            setInitialLoading(true);
            setLoading(true);
            try {
                const resDistrict = await axios.get(district_admin, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });

                // console.log("resDistrict", resDistrict.data);
                setDistrict(resDistrict.data);
            } catch (err) {
                console.error("Fetch district error:", err);
                setErrorSnackbar({
                    open: true,
                    message: "โหลดข้อมูลล้มเหลว",
                });
            } finally {
                setLoading(false);
                setInitialLoading(false);
            }
        };
        if (placeType) {
            setForm((prevForm) => ({
                ...prevForm,
                placeType: placeType, // ตั้งค่า placeType เข้าฟอร์ม
            }));
        }

        fetchData();
    }, [token, placeType]); // ✅ เพิ่ม token ใน dependency array

    const handleChange = (field) => (event) => {
        const input = event.target;
        let value = input.value;
        setForm((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSwitchChange = (event) => {
        setForm((prev) => ({
            ...prev,
            language: event.target.checked ? "th" : "en",
        }));
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const handleCancel = () => {
        // ล้างข้อมูลฟอร์ม
        setForm({
            placeType: "",  // หมวดที่อยู่
            attractionName: "",  // ชื่อสถานที่
            language: "th",  // ภาษา
            bannerImage: "",   // เลือกไฟล์รูป BANNER
            detailedImage: "",   // เลือกไฟล์รูปละเอียด
            historyDescription: "", // ประวัติความเป็นมา
            activities: "", // กิจกรรม
            cost: "", // ค่าใช้จ่าย
            touristCapacity: "", // การรองรับนักท่องเที่ยว
            openingHours: "", // เวลาทำการ
            touristSeason: "", // ฤดูการท่องเที่ยว
            electricityUsage: "", // การใช้ไฟฟ้า
            waterUsage: "", // การใช้น้ำ
            fuelUsage: "", // การใช้น้ำมัน
            wastewaterManagement: "", // การจัดการน้ำและการเปลี่ยนถ่ายน้ำเสีย
            wasteManagement: "", // การจัดการขยะ
            carFootprintPerDay: "", // คาร์ฟุตพริ้นท์/วัน
            ecoSystemChange: "", // การเปลี่ยนระบบของสถานที่ท่องเที่ยว
            contactInfo: "", // ติดต่อสถานที่s
            locationDescription: "", // ที่ตั้ง
            googleMapCoordinates: "", // Google Map (latitude,longitude)
            notes: "", // หมายเหตุ
            // uid: "", // ไอดีผู้ลงข้อมูล
            // did: "", // ไอดีจังหวัด
        });
    };

    // อัพโหลดรูปภาพ
    const handleImageUpload = (e, type) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            const newImages = files.map((file) => ({
                type,
                file,
                name: file.name,
                preview: URL.createObjectURL(file),
            }));

            const otherImages = images.filter((img) => img.type !== type);
            setImages([...otherImages, ...newImages]);
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // ✅ เริ่มโหลด
        try {
            const decoded = jwtDecode(token);
            const uid = decoded?.uid || decoded?.user_id || null;
            // STEP 1: สร้างสถานที่ (place)
            const placePayload = {
                ...form,
                uid: parseInt(uid),
                carFootprintPerDay: parseFloat(form.carFootprintPerDay),
            };

            const placeRes = await axios.post(create_places, placePayload, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            // console.log("placeRes", placeRes);

            if (placeRes.status === 200 && placeRes.data?.id) {
                // const newRouteId = 7;
                const newRouteId = placeRes.data?.id;
                const types = [...new Set(images.map((img) => img.type))];

                let allUploads = []; // เก็บผลลัพธ์ทุกกลุ่ม
                let allSuccess = true;

                // ✅ วนลูปแต่ละ type
                for (const type of types) {
                    const imagesOfType = images.filter((img) => img.type === type);
                    if (imagesOfType.length === 0) continue;

                    const formDataUpload = new FormData();

                    // ✅ เพิ่มรูปทั้งหมดในกลุ่มนั้น
                    imagesOfType.forEach((img) => {
                        formDataUpload.append("files", img.file);
                    });

                    // ✅ เพิ่มข้อมูลอื่น ๆ
                    formDataUpload.append("media_type", "image");
                    formDataUpload.append("type", type);
                    formDataUpload.append("place_type", "place");
                    formDataUpload.append("ref_id", newRouteId);
                    formDataUpload.append("ref_name", "place");

                    // console.log(`📤 Uploading type: ${type}, จำนวนรูป: ${imagesOfType.length}`);

                    try {
                        const uploadRes = await axios.post(upload_image_all, formDataUpload, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type": "multipart/form-data",
                            },
                            onUploadProgress: (progressEvent) => {
                                const percent = Math.round(
                                    (progressEvent.loaded * 100) / progressEvent.total
                                );
                                console.log(`📈 Progress ${type}: ${percent}%`);
                            },
                        });
                        // console.log("uploadRes", uploadRes);

                        if (uploadRes.status === 200 || uploadRes?.status === 201) {
                            const data = uploadRes.data;
                            console.log(`✅ Upload ${type} success:`, data);
                            allUploads.push({ type, data });
                        } else {
                            console.warn(`⚠️ Upload ${type} failed:`, uploadRes.status);
                            allSuccess = false;
                        }
                    } catch (uploadError) {
                        console.error(`❌ Error uploading ${type}:`, uploadError);
                        allSuccess = false;
                    }
                }

                // ✅ เมื่ออัปโหลดครบทุกประเภท
                if (allSuccess && allUploads.length > 0) {
                    setSnackbarMessage("✅ อัปโหลดรูปภาพทั้งหมดสำเร็จ!");
                    setSnackbarSeverity("success");

                    // เคลียร์ค่า
                    setImages([]);
                    setForm({
                        attractionName: "",
                        language: "th",
                        historyDescription: "",
                        activities: "",
                        cost: "",
                        touristCapacity: "",
                        openingHours: "",
                        touristSeason: "",
                        electricityUsage: "",
                        waterUsage: "",
                        fuelUsage: "",
                        wastewaterManagement: "",
                        wasteManagement: "",
                        carFootprintPerDay: "",
                        ecoSystemChange: "",
                        contactInfo: "",
                        locationDescription: "",
                        googleMapCoordinates: "",
                        notes: "",
                    });
                } else {
                    setSnackbarMessage("⚠️ บางรูปอัปโหลดไม่สำเร็จ");
                    setSnackbarSeverity("warning");
                }
            } else {
                throw new Error("Place creation failed");
            }
        } catch (error) {
            console.error("❗ Error ส่งข้อมูล:", error);
            setSnackbarMessage("⚠️ เกิดข้อผิดพลาดขณะส่งข้อมูล");
            setSnackbarSeverity("error");
        } finally {
            setLoading(false); // ✅ หยุดโหลดเมื่อเสร็จ
            setSnackbarOpen(true);
            setLoading(false); // 🔚 หยุดโหลด
        }
    };

    const placeTypeLabels = {
        tourist_attraction: "สถานที่ท่องเที่ยว",
        hotel: "ที่พัก",
        restaurant: "ร้านอาหาร",
        gift_shop: "ร้านของที่ระลึก",
        community_product: "ผลิตภัณฑ์ชุมชน",
    };
    // ลบรูปภาพ
    const handleRemoveImage = (indexToRemove, type) => {
        const updatedImages = images
            .filter((img, index) => !(index === indexToRemove && img.type === type));

        // เคลียร์ memory
        const removedImg = images.find((img, index) => index === indexToRemove && img.type === type);
        if (removedImg?.preview) {
            URL.revokeObjectURL(removedImg.preview);
        }

        setImages(updatedImages);
    };

    const HeaderIcon = placeTypeIcons[placeType] || Place;
    const fieldIcon = (Icon) => ({
        startAdornment: <InputAdornment position="start"><Icon sx={{ color: GREEN }} /></InputAdornment>,
    });
    const dropZoneSx = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        p: 3,
        textAlign: "center",
        cursor: "pointer",
        borderRadius: 3,
        border: "2px dashed #aed581",
        bgcolor: "#fafdf7",
        color: GREEN,
        transition: "all .2s",
        "&:hover": { borderColor: GREEN, bgcolor: LIGHT },
    };
    const renderPreviews = (type) => (
        <Box sx={{ mt: 1.5, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(96px, 1fr))", gap: 1 }}>
            {images
                .filter((img) => img.type === type)
                .map((img, index) => (
                    <Box key={index} sx={{ borderRadius: 2, overflow: "hidden", border: `1px solid ${BORDER}`, bgcolor: "white" }}>
                        <Box
                            component="img"
                            src={img.preview}
                            alt={`${type} preview ${index}`}
                            sx={{ width: "100%", height: 80, objectFit: "cover", display: "block" }}
                        />
                        <Typography variant="caption" noWrap component="div" sx={{ px: 0.75, py: 0.25, color: "text.secondary" }}>
                            {img.name}
                        </Typography>
                    </Box>
                ))}
        </Box>
    );

    return (
        <Box component="form" onSubmit={handleSubmit}>
            {loading && (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                </div>
            )}
            <AdminPage
                icon={<HeaderIcon fontSize="large" />}
                title={placeTypeLabels[placeType] || placeType.replaceAll("_", " ")}
                subtitle="กรอกข้อมูลทั่วไป รูปภาพ รายละเอียด และข้อมูลด้านสิ่งแวดล้อมของสถานที่"
                maxWidth={1000}
                actions={
                    <>
                        <Button
                            variant="outlined"
                            color="error"
                            size="large"
                            startIcon={<Cancel />}
                            onClick={handleCancel}
                            sx={{ px: 3, borderRadius: 3, width: { xs: "100%", sm: "auto" } }}
                        >
                            ยกเลิก
                        </Button>
                        <Button
                            variant="contained"
                            size="large"
                            type="submit"
                            disabled={loading}
                            startIcon={<Save />}
                            sx={primaryButtonSx}
                        >
                            บันทึก
                        </Button>
                    </>
                }
            >
                {/* ข้อมูลทั่วไป */}
                <SectionTitle step={1} title="ข้อมูลทั่วไป" />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="ชื่อสถานที่"
                            value={form.attractionName}
                            onChange={handleChange("attractionName")}
                            InputProps={fieldIcon(HeaderIcon)}
                            sx={{ bgcolor: "white" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel id="district-label">เลือกอำเภอ</InputLabel>
                            <Select
                                labelId="district-label"
                                label="เลือกอำเภอ"
                                value={form.did}
                                onChange={handleChange("did")}
                                startAdornment={<InputAdornment position="start"><LocationOn sx={{ color: GREEN }} /></InputAdornment>}
                                sx={{ bgcolor: "white" }}
                            >
                                <MenuItem value="">
                                    <em>-- เลือกอำเภอ --</em>
                                </MenuItem>
                                {district?.length > 0 &&
                                    district.map((d) => (
                                        <MenuItem key={d.did} value={d.did}>
                                            {d.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                bgcolor: LIGHT,
                                border: `1px solid ${BORDER}`,
                                borderRadius: 3,
                                px: 2,
                                py: 1,
                            }}
                        >
                            <Language sx={{ color: GREEN }} />
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.language === "th"}
                                        onChange={handleSwitchChange}
                                        color="success"
                                    />
                                }
                                label={
                                    <Typography sx={{ fontWeight: 600 }}>
                                        ใช้สำหรับภาษา: {form.language}
                                    </Typography>
                                }
                            />
                        </Box>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />
                <SectionTitle step={2} title="รูปภาพ" />
                <Grid container spacing={2}>
                    {/* Banner Place (1 รูป) */}
                    <Grid item xs={12} sm={6}>
                        <Box component="label" sx={dropZoneSx}>
                            <Image sx={{ fontSize: 40 }} />
                            <Typography fontWeight={600}>เลือกรูปโปรไฟล์สถานที่</Typography>
                            <Typography variant="caption" color="text.secondary">คลิกเพื่อเลือกไฟล์รูปภาพ</Typography>
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                hidden
                                onChange={(e) => handleImageUpload(e, "banner_place")}
                            />
                        </Box>
                        {/* แสดง preview banner_place */}
                        {renderPreviews("banner_place")}
                    </Grid>

                    {/* Detailed Images (หลายรูป) */}
                    <Grid item xs={12} sm={6}>
                        <Box component="label" sx={dropZoneSx}>
                            <Collections sx={{ fontSize: 40 }} />
                            <Typography fontWeight={600}>เลือกรูปสไลด์ของสถานที่</Typography>
                            <Typography variant="caption" color="text.secondary">เลือกได้หลายรูป</Typography>
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                hidden
                                onChange={(e) => handleImageUpload(e, "img_detail_place")}
                            />
                        </Box>
                        {/* แสดง preview หลายภาพ */}
                        {renderPreviews("img_detail_place")}
                    </Grid>
                </Grid>

                {/* รายละเอียด */}
                <Divider sx={{ my: 3 }} />
                <SectionTitle step={3} title="รายละเอียด" />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="ประวัติและความเป็นมา"
                            multiline
                            minRows={3}
                            value={form.historyDescription}
                            onChange={handleChange("historyDescription")}
                            sx={{ bgcolor: "white" }}
                        />
                    </Grid>

                    {[
                        ["กิจกรรม", "activities", Spa],
                        ["ค่าใช้จ่าย", "cost", Payments],
                        ["การรองรับนักท่องเที่ยว", "touristCapacity", Groups],
                        ["เวลาทำการ", "openingHours", AccessTime],
                        ["ฤดูกาลท่องเที่ยว", "touristSeason", WbSunny],
                        ["คาร์ฟุตพริ้นท์/วัน", "carFootprintPerDay", Co2],

                    ].map(([label, key, Icon]) => (
                        <Grid item xs={12} sm={6} key={key}>
                            <TextField
                                fullWidth
                                label={label}
                                value={form[key]}
                                onChange={handleChange(key)}
                                InputProps={fieldIcon(Icon)}
                                sx={{ bgcolor: "white" }}
                            />
                        </Grid>
                    ))}
                </Grid>

                {/* ความยั่งยืน */}
                <Divider sx={{ my: 3 }} />
                <SectionTitle step={4} title="ความยั่งยืน & สิ่งแวดล้อม" />
                <Grid container spacing={2}>
                    {[
                        ["การใช้ไฟฟ้า", "electricityUsage", Bolt],
                        ["การใช้น้ำ", "waterUsage", WaterDrop],
                        ["การใช้น้ำมัน", "fuelUsage", LocalGasStation],
                        ["การจัดการน้ำและการเปลี่ยนถ่ายน้ำเสีย", "wastewaterManagement", WaterDrop],
                        ["การจัดการขยะ", "wasteManagement", Recycling],
                        ["การเปลี่ยนระบบของสถานที่ท่องเที่ยว", "ecoSystemChange", Park],
                    ].map(([label, key, Icon]) => (
                        <Grid item xs={12} sm={6} key={key}>
                            <TextField
                                fullWidth
                                label={label}
                                value={form[key]}
                                onChange={handleChange(key)}
                                InputProps={fieldIcon(Icon)}
                                sx={{ bgcolor: "white" }}
                            />
                        </Grid>
                    ))}
                </Grid>

                {/* ติดต่อ */}
                <Divider sx={{ my: 3 }} />
                <SectionTitle step={5} title="การติดต่อและแผนที่" />
                <Grid container spacing={2}>
                    {[
                        ["ติดต่อสถานที่", "contactInfo", Phone],
                        ["ที่ตั้ง", "locationDescription", LocationOn],
                    ].map(([label, key, Icon]) => (
                        <Grid item xs={12} sm={6} key={key}>
                            <TextField
                                fullWidth
                                label={label}
                                value={form[key]}
                                onChange={handleChange(key)}
                                InputProps={fieldIcon(Icon)}
                                sx={{ bgcolor: "white" }}
                            />
                        </Grid>
                    ))}

                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Google Map (latitude,longitude)"
                            value={form.googleMapCoordinates}
                            onChange={handleChange("googleMapCoordinates")}
                            multiline
                            minRows={2}
                            placeholder="เช่น 16.76031995300121, 103.33303807244201"
                            InputProps={fieldIcon(MapIcon)}
                            sx={{ bgcolor: "white" }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="หมายเหตุ"
                            value={form.notes}
                            onChange={handleChange("notes")}
                            InputProps={fieldIcon(Notes)}
                            sx={{ bgcolor: "white" }}
                        />
                    </Grid>
                </Grid>
            </AdminPage>
            {/* // JSX ส่วนแสดง error Snackbar */}
            <Snackbar
                open={errorSnackbar.open}
                autoHideDuration={3000}
                onClose={() => setErrorSnackbar({ open: false, message: "" })}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    severity="error"
                    variant="filled"
                    sx={{ fontWeight: "bold" }}
                >
                    {errorSnackbar.message}
                </Alert>
            </Snackbar>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={initialLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Box>

    );
}

export default MainAddPlaces